import { render, staticRenderFns } from "./AnaliseIA.vue?vue&type=template&id=b810f43a&scoped=true&"
import script from "./AnaliseIA.vue?vue&type=script&lang=js&"
export * from "./AnaliseIA.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseIA.vue?vue&type=style&index=0&id=b810f43a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b810f43a",
  null
  
)

export default component.exports